class NavBarController {
    constructor($browser, $window, $location, $uibModal, ModalService, UserDetailsApi, PermissionsServiceApi, AppServiceApi, TraceHubExService, UtpSysMessagesServiceApi, TestNotesServiceApi, ReportAccessServiceApi, SettingsExService, DynamicMenuServiceApi, NotifyService, moment, UserServiceApi, multiTestNotificationService, $scope, StateService, NotificationsServiceApi, $localStorage, toastr) {
        this.$onInit = () => {
            this.window.document.title = "Web Based Testing";
            this.userDetails = {};
            this.systemInfo = {};
            this.menuItems = {};
            this.state = {
                sysMessagesLength: 0,
                testNotesLength: 0,
                appSettings: {},
                connectionId: "",
                lastLoginTime: "",
                multiTestIsRunning: false,
                reportsLoading: true,
                canAccessCMP: false,
            };
            this.data = {
                reports: {},
                testNotesLength: 0,
                users: {},
            };
            this.systemNotificationMessage = '';
            // Initialise the Notifications status
            this.isActive = this.NotifyService.isActive();
            // set to true initially so we dont display the reset password until
            // we get the updated config
            this.state.appSettings.UseSingleSignOn = true;
            // Getting User details
            // Update the timezone before doing anything else since it will allow UserDetailsApi to return the correct offset
            this.UserServiceApi.timezoneOffset(this.getTimezoneOffset()).then(() => {
                this.UserDetailsApi.get().then((response) => {
                    this.userDetails = response.data;
                    // Getting App settings
                    this.SettingsService.getSettings().then((response) => {
                        let appSettingsResponse = response.data;
                        this.state.appSettings = appSettingsResponse;
                        this.state.lastLoginTime = this.moment
                            .utc(this.userDetails.LastLoginTime)
                            .local()
                            .format(this.state.appSettings.DateTimeFormat);
                        this.AppServiceApi.systemInfo().then((response) => {
                            this.systemInfo = response.data;
                            this.ReportAccessService.getReportAccessGridAsListStrings().then((response) => {
                                this.bindReports(response.data);
                            });
                        });
                        this.testNotesCount();
                        this.NotificationsServiceApi.getLiveNotifications().then((response) => {
                            if (response.data.length > 0) {
                                this.showNotifications(response.data);
                                _.filter(response.data, (notification) => {
                                    let notificationType = notification.Type;
                                    if (notificationType === 'SystemAlert') {
                                        this.systemNotificationMessage = notification.Message;
                                    }
                                });
                            }
                        });
                        this.PermissionsServiceApi.getPermissionsForConnectedUser().then((response) => {
                            const connectedUserPermissions = response.data;
                            const hasCMPAccessPermission = connectedUserPermissions.indexOf('wbt:cmp_access') >= 0;
                            this.state.canAccessCMP =
                                this.state.appSettings.CMPEnabled &&
                                    this.state.appSettings.CMPURL.length &&
                                    hasCMPAccessPermission;
                        });
                        this.DynamicMenuServiceApi.navItems()
                            .then((response) => response.data)
                            .then((menuItems) => (this.menuItems = menuItems));
                        this.TraceHubExService.connectWithSpecificTransport("NavBarController", this.state.appSettings.SignalRTransport);
                        this.TraceHubExService.on("NavBarController", "onInit", (connId) => {
                            this.state.connectionId = connId;
                        });
                        this.TraceHubExService.on("NavBarController", "onNotificationSave", (notification) => {
                            // required here due to enum translation from C# to TS (comes in as a string, but the type is expected to be an int)
                            let notificationType = notification.Type;
                            if (notificationType === "SystemAlert") {
                                this.systemNotificationMessage = notification.Message;
                            }
                            this.showNotifications([notification]);
                        });
                        this.TraceHubExService.on("NavBarController", "onTestNote", () => {
                            this.testNotesCount();
                        });
                        this.TraceHubExService.on("NavBarController", "OnUserDelete", (userId) => {
                            if (this.userDetails.Id === userId) {
                                this.signOff();
                            }
                        });
                        this.TraceHubExService.on("NavBarController", "OnConcurrentUserLogin", () => {
                            this.openConcurrentUserLoginAlert();
                        });
                    });
                });
            });
        };
        this.$onDestroy = () => {
            this.TraceHubExService.stop("NavBarController");
        };
        this.bindReports = (data) => {
            this.data.reports = data;
            this.data.reports = this.discardInvalid(this.data.reports);
            if (this.data.reports.length > 0 &&
                this.data.reports.some((r) => r.Report.IsExternal)) {
                this.multiTestNotificationService.listenForMultiRun(this.$scope, this.toggleDisability);
            }
            this.state.reportsLoading = false;
        };
        this.toggleDisability = (event, e) => {
            this.data.reports.forEach((r) => {
                if (r.Report.IsExternal && r.SimIds.some((i) => i === e.simId)) {
                    this.state.multiTestIsRunning = e.multiTestIsRunning;
                }
            });
        };
        this.getTimezoneOffset = () => {
            let currentDate = new Date();
            let timezoneOffset = currentDate.getTimezoneOffset();
            return timezoneOffset;
        };
        this.setActive = (isActive) => {
            if (isActive) {
                this.NotifyService.switchOn();
            }
            else {
                this.NotifyService.switchOff();
            }
        };
        this.goToRuf = (page) => {
            this.window.location.href =
                this.browser.baseHref() + page.replace("Admin#/", "");
        };
        this.signOff = () => {
            // Switch off SignalR
            this.TraceHubExService.stop("NavBarController");
            // Relocate to Account/LogoffView
            this.relocate("Account/LogoffView");
        };
        this.showChangePassword = () => {
            if (this.state.appSettings.UseSingleSignOn === true) {
                return false;
            }
            return true;
        };
        this.changePassword = () => {
            this.uibModal.open({
                backdrop: "static",
                component: "changePasswordComponent",
                size: "sm",
            }).result.then(() => {
                this.toastr.info('Password has been changed successfully.');
            });
        };
        this.uploads = () => {
            this.location.path("/Uploads/AspNetUsers/" + this.userDetails.Id);
        };
        this.locationPath = (url) => {
            if (this.location.path() === url) {
                location.reload();
            }
            else {
                this.location.path(url);
            }
        };
        // Navigation Links
        this.relocate = (cLocation) => {
            location.replace(this.browser.baseHref() + cLocation);
        };
        this.testNotesCount = () => {
            this.TestNotesService.unreadTestNotesCount().then((response) => {
                let num = response.data;
                this.data.testNotesLength = num;
            });
        };
        this.showNotes = () => {
            if (this.data.testNotesLength === 0) {
                return;
            }
            let modalInstance = this.uibModal.open({
                animation: true,
                size: "msg",
                backdrop: "static",
                component: "navNotesModal", // ,
                // resolve: {}
            });
        };
        this.discardInvalid = (reports) => {
            // Remove any disabled reports
            reports = _.filter(reports, (report) => {
                return !report.Report.IsDeleted;
            });
            let res = _.filter(reports, (report) => {
                let roles = report.AssignedRoles;
                let i = 0;
                for (i = 0; i < roles.length; i++) {
                    if (roles[i] === this.userDetails.CoreRole) {
                        return true;
                    }
                }
                return false;
            });
            return res;
        };
        this.showReport = (report) => {
            if (report.Name === "CapacityReport") {
                this.uibModal.open({
                    animation: true,
                    size: "md",
                    backdrop: "static",
                    component: "capacityReport",
                    resolve: {
                        capacityReport: report,
                    },
                });
            }
            else {
                this.location.path("/Reports/" + report.Name);
            }
        };
        this.goToTraceSummaryFromMenu = () => {
            const user = this.userDetails.IsTester || this.userDetails.IsGroupTester
                ? {
                    Id: this.userDetails.Id,
                    Name: this.userDetails.UserName,
                }
                : { Id: -1, Name: "unknown" };
            this.StateService.reset();
            this.StateService.selectedTester = user;
            this.locationPath(`TraceSummary`);
        };
        this.openConcurrentUserLoginAlert = () => {
            let modalOptions = {
                backdrop: "static",
                actionButtonText: "OK",
                closeButtonText: "Close",
                headerText: "Concurrent user login",
                bodyText: "A new login into your account has been detected",
                okOnly: true,
            };
            this.ModalService.showModal({}, modalOptions);
        };
        this.dateDiffInDays = (lastSeenDate, now) => {
            // Milliseconds in a day
            const _MS_PER_DAY = 1000 * 60 * 60 * 24;
            // Discard the time and time-zone information.
            let a = new Date(lastSeenDate);
            let b = new Date(now);
            const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
            const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());
            return Math.floor((utc2 - utc1) / _MS_PER_DAY);
        };
        this.showNotifications = (notificationDetailsList) => {
            if (this.localStorage.NotificationAcknowledged) {
                let lastSeenDate = this.localStorage.NotificationAcknowledged;
                const now = new Date();
                let diffDays = this.dateDiffInDays(lastSeenDate, now);
                if (diffDays < 1) {
                    return;
                }
            }
            if (this.NotificationDialog) {
                this.NotificationDialog.dismiss();
            }
            this.NotificationDialog = this.uibModal.open({
                animation: true,
                backdrop: "static",
                component: "notificationsModal",
                resolve: {
                    notifications: () => {
                        return notificationDetailsList;
                    },
                },
            });
            this.NotificationDialog.result.then(() => {
                this.NotificationDialog = null;
            });
        };
        this.browser = $browser;
        this.window = $window;
        this.location = $location;
        this.uibModal = $uibModal;
        this.ModalService = ModalService;
        this.UserDetailsApi = UserDetailsApi;
        this.AppServiceApi = AppServiceApi;
        this.TraceHubExService = TraceHubExService;
        this.UtpSysMessagesServiceApi = UtpSysMessagesServiceApi;
        this.TestNotesService = TestNotesServiceApi;
        this.ReportAccessService = ReportAccessServiceApi;
        this.SettingsService = SettingsExService;
        this.DynamicMenuServiceApi = DynamicMenuServiceApi;
        this.NotifyService = NotifyService;
        this.moment = moment;
        this.UserServiceApi = UserServiceApi;
        this.PermissionsServiceApi = PermissionsServiceApi;
        this.multiTestNotificationService = multiTestNotificationService;
        this.$scope = $scope;
        this.StateService = StateService;
        this.NotificationsServiceApi = NotificationsServiceApi;
        this.localStorage = $localStorage;
        this.toastr = toastr;
    }
}
angular.module('app').component('navBar', {
    templateUrl: 'scripts/app/partials/nav/nav.tpl.html',
    controllerAs: 'vm',
    controller: NavBarController
});
